import CampaignList from './CampaignList'
import { CampaignsEdit } from './CampaignsEdit'
import { CampaignsCreate } from './CampaignsCreate'
import CampaignsShow from './CampaignsShow'

export default {
  create: CampaignsCreate,
  edit: CampaignsEdit,
  list: CampaignList,
  show: CampaignsShow,
}
